// extracted by mini-css-extract-plugin
export default {"icon-button":"icon-button__md1nA","primary":"primary__faco-","secondary":"secondary__H3LsP"};